import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/chicago/access_chicago.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Access Top-Tier Mobile App Development Services in Chicago</h2>
            <p>
              Be it a startup, scaling venture, or enterprise, TekRevol help
              all-sized businesses thrive more and better. From interactive
              frontends to extensible backends, our mobile app developers in
              Chicago use novel technologies and systematic workflows to develop
              business-specific, performant solutions.
            </p>
            <p>
              Add a powerful user-facing digital platform to your business
              ecosystem and tap into new growth opportunities with better
              engagement, compelling experiences, and higher returns. Whether
              your goal is to win over Android or Apple users or dominate across
              platforms, our custom mobile app development services in Chicago
              adapt seamlessly to your needs.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Start App Development
            </Link>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto order-2 order-lg-1"
          >
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
